import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ControlledSelect, ControlledCheckbox, ControlledDatePicker } from 'app/custom-components/form-components';

const parseErrorMessage = (fieldName, errors) => {
    const nestedName = fieldName.split('.');
    return errors[fieldName] || (nestedName.length && nestedName.reduce((acc, key) => acc?.[key], errors));
};

const UserCustomFieldValue = ({ customField, fieldName }) => {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const error = parseErrorMessage(fieldName, errors);
    switch (customField.data_type) {
        case 'string':
            return (
                <TextField
                    sx={{ my: 1 }}
                    placeholder={`Enter ${customField.name}`}
                    {...register(fieldName)}
                    error={!!error}
                    helperText={error?.message}
                    size="small"
                    fullWidth
                    // wrap
                />
            );
        case 'number':
            return (
                <TextField
                    sx={{ my: 1 }}
                    placeholder={`Enter ${customField.name}`}
                    {...register(fieldName)}
                    error={!!error}
                    helperText={error?.message}
                    type="number"
                    size="small"
                    fullWidth
                    // wrap
                />
            );
        case 'date':
            return (
                <ControlledDatePicker
                    name={fieldName}
                    label={customField.name}
                    slotProps={{
                        textField: {
                            size: 'small',
                            error: !!error,
                            helperText: error?.message,
                        },
                    }}
                />
            );
        case 'boolean':
            return <ControlledCheckbox name={fieldName} label={customField.name} />;
        case 'select': {
            return <ControlledSelect options={customField.options ?? []} name={fieldName} label={customField.name} size="small" fullWidth />;
        }
        case 'multi_line':
            return (
                <TextField
                    sx={{ my: 1 }}
                    placeholder={`Enter ${customField.name}`}
                    {...register(fieldName)}
                    error={!!error}
                    helperText={error?.message}
                    multiline
                    rows={4}
                    size="small"
                    fullWidth
                    // wrap
                />
            );
        default:
            return (
                <TextField
                    sx={{ my: 1 }}
                    placeholder={`Enter ${customField.name}`}
                    {...register(fieldName)}
                    error={!!error}
                    helperText={error?.message}
                    size="small"
                    fullWidth
                    // wrap
                />
            );
    }
};

export default UserCustomFieldValue;
